module.exports = __webpack_public_path__ + "img/icon.d9a45b8a.jpg";